<!--Options-->
<div class="SearchOptionBorder TopMargin">
	<h4>Search Options:</h4>

	<div class="SearchOptionDiv">
		<label>School:</label>
		<caass-schoolselector [ShowAll]="false"></caass-schoolselector>

		<label>Expire In:</label>
		<div class="InfoGrid2Col">
			<input
				[disabled]="IsLoading() == true"
				class="form-control"
				type="number"
				[(ngModel)]="ExpireDayCount"
				step="1"
				min="0"
				(ngModelChange)="onExpireDayCountChange($event)"
			/>
			<label>days</label>
		</div>

		<label>Expires On:</label>
		<p-calendar
			[disabled]="IsLoading() == true"
			showIcon="true"
			showButtonBar="true"
			[(ngModel)]="ExpireDate"
			name="ExpireDate"
			(ngModelChange)="onExpireDateChange($event)"
		></p-calendar>

		<label>Grade:</label>
		<p-dropdown
			[disabled]="IsLoading() == true"
			[options]="lstGradeLevel"
			[(ngModel)]="SelectedGradeLevel"
			optionLabel="GradeLevelDesc"
			[filter]="true"
			filterBy="GradeLevelDesc"
			[showClear]="false"
			placeholder="Select a Grade Level"
		>
			<ng-template pTemplate="selectedItem">
				<div *ngIf="SelectedGradeLevel">
					<div class="form-control NoBorder" style="text-align: left">
						{{ SelectedGradeLevel.GradeLevelDesc }}
					</div>
				</div>
			</ng-template>
			<ng-template let-GradeLevelItem pTemplate="item">
				<div>
					<div class="form-control NoBorder" style="text-align: left">
						{{ GradeLevelItem.GradeLevelDesc }}
					</div>
				</div>
			</ng-template>
		</p-dropdown>

		<label>Academy:</label>
		<p-dropdown
			[disabled]="IsLoading() == true"
			[options]="lstAcademy"
			[(ngModel)]="SelectedAcademy"
			optionLabel="AcademyDesc"
			[filter]="true"
			filterBy="AcademyDesc"
			[showClear]="false"
			placeholder="Select an Academy"
		>
			<ng-template pTemplate="selectedItem">
				<div *ngIf="SelectedAcademy">
					<div class="form-control NoBorder" style="text-align: left">
						{{ SelectedAcademy.AcademyDesc }}
					</div>
				</div>
			</ng-template>
			<ng-template let-AcademyItem pTemplate="item">
				<div>
					<div class="form-control NoBorder" style="text-align: left">
						{{ AcademyItem.AcademyDesc }}
					</div>
				</div>
			</ng-template>
		</p-dropdown>

		<label>Homeroom:</label>
		<p-dropdown
			[disabled]="IsLoading() == true"
			[options]="lstHomeroom"
			[(ngModel)]="SelectedHomeroom"
			optionLabel="HomeRoom"
			[filter]="true"
			filterBy="HomeRoom"
			[showClear]="false"
			placeholder="Select a Homeroom"
		>
			<ng-template pTemplate="selectedItem">
				<div *ngIf="SelectedHomeroom">
					<div class="form-control NoBorder" style="text-align: left">
						{{ SelectedHomeroom.HomeRoom }}
					</div>
				</div>
			</ng-template>
			<ng-template let-HomeroomItem pTemplate="item">
				<div>
					<div class="form-control NoBorder" style="text-align: left">
						{{ HomeroomItem.HomeRoom }}
					</div>
				</div>
			</ng-template>
		</p-dropdown>

		<label>Group:</label>
		<p-dropdown
			[disabled]="IsLoading() == true"
			[options]="lstGroup"
			[(ngModel)]="SelectedGroup"
			optionLabel="GroupName"
			[filter]="true"
			filterBy="GroupName"
			[showClear]="false"
			placeholder="Select a Group"
		>
			<ng-template pTemplate="selectedItem">
				<div *ngIf="SelectedGroup">
					<div class="form-control NoBorder" style="text-align: left">
						{{ SelectedGroup.GroupName }}
					</div>
				</div>
			</ng-template>
			<ng-template let-GroupItem pTemplate="item">
				<div>
					<div class="form-control NoBorder" style="text-align: left">
						{{ GroupItem.GroupName }}
					</div>
				</div>
			</ng-template>
		</p-dropdown>

		<label>Active:</label>
		<select [disabled]="IsLoading() == true" class="form-control" name="ActiveID" [(ngModel)]="ActiveID">
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstActiveOption" [ngValue]="o.ID">{{ o.Desc }}</option>
		</select>

		<label>Already Printed:</label>
		<select [disabled]="IsLoading() == true" class="form-control" name="AlreadyPrintedID" [(ngModel)]="AlreadyPrintedID">
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstAlreadyPrintedOption" [ngValue]="o.ID">{{ o.Desc }}</option>
		</select>

		<label>Sort By:</label>
		<select [disabled]="IsLoading() == true" class="form-control" name="SortBy" [(ngModel)]="SortBy">
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstSortBy" [ngValue]="o.ID">{{ o.Desc }}</option>
		</select>

		<label>Sort Direction:</label>
		<select [disabled]="IsLoading() == true" class="form-control" name="SortDirection" [(ngModel)]="SortDirection">
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstSortDirection" [ngValue]="o.ID">{{ o.Desc }}</option>
		</select>

		<label>Create File Type:</label>
		<select [disabled]="IsLoading() == true" class="form-control" name="ReportOutputTypeID" [(ngModel)]="ReportOutputTypeID">
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstReportOutputType" [ngValue]="o.ID">{{ o.Desc }}</option>
		</select>
	</div>
</div>

<div class="Buttons">
	<button [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onPrint()">Print</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>
	<div name="Saveing" *ngIf="Processing" class="alert alert-info">Processing.Please wait...</div>
</div>
